import { TriviaList } from '@repo/types'
import { Button, Spinner } from '@repo/ui'
import { Dialog } from '@repo/ui/client'

import { TriviaListPreview } from './TriviaListPreview'

interface TriviaListPreviewModalProps {
  isLoading: boolean
  isVisible: boolean
  onClickCreateGame: () => void
  onClose: () => void
  triviaList: TriviaList | null
}

export function TriviaListPreviewModal({
  isLoading,
  isVisible,
  onClickCreateGame,
  onClose,
  triviaList
}: TriviaListPreviewModalProps) {
  return (
    <Dialog className='max-h-[clamp(240px,90vh,680px)]' isVisible={isVisible}>
      <Dialog.Header>
        <Dialog.Title>Preview: {triviaList?.title}</Dialog.Title>
        <Dialog.CloseButton onClick={onClose} />
      </Dialog.Header>
      <Dialog.Separator />
      <Dialog.Body className='pt-0'>
        {isLoading && <Spinner label='Loading trivia list...' />}

        {!isLoading && triviaList && <TriviaListPreview triviaList={triviaList} />}
      </Dialog.Body>
      <Dialog.Footer>
        <Button disabled={isLoading} text='Create Game' onClick={() => void onClickCreateGame()} />
      </Dialog.Footer>
    </Dialog>
  )
}
